// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";
import User from "app/models/User";

import EditButton from "app/components/EditButton/EditButton";
import NotSupportedCard from "app/components/TimelineCard/NotSupportedCard/NotSupportedCard";
import Overlay from "app/components/Overlay/Overlay";
import TimelineCardSocial from "app/components/TimelineCardSocial/TimelineCardSocial";
import TimelineItemDelete from "app/components/TimelineItemDelete/TimelineItemDelete";
import WizardTimelineCard from "app/components/TimelineCard/WizardTimelineCard/WizardTimelineCard";

import "./TimelineCard.scss";

export type Props = {
    userId: ?number,
    user: ?User,
    isOwner: boolean,
    video: Video,
    item: TimelineItem,
    onRequestPauseMainVideo: Function,
    onSeek: Function,
    onSave: Function,
    onRequestEdit: Function,
    onCancelWizard: Function,
    onChange: Function,
    onDelete: Function,
    onReact: Function,
    onComment: Function,
    onDeleteComment: Function,
    scale: number,
    wizard: boolean,
    editable: boolean,
    serverTime: any,
    isVerticalView: boolean,
    isExpanded: boolean,
    onExpand: Function,
    onUnExpand: Function
};

@observer
export default class TimelineCard extends React.Component<Props> {
    static types: { [string]: Function } = {};

    static pushType(type: string, component: Function) {
        this.types[type] = component;
    }

    handleSeek = () => {
        this.props.onSeek(this.props.item.start_time);
    };

    render() {
        const item = this.props.item;
        let classes = [
            "TimelineCard",
            "TimelineCard--" + (this.props.wizard ? "wizard" : item.type),
            "TimelineCard--" + (item.rowid ? "existing" : "new")
        ];

        return (
            <div className={classes.join(" ")}>
                {this.props.wizard && (
                    <Overlay onClick={this.props.onCancelWizard} />
                )}

                <div className="TimelineCard__content">
                    <div className="TimelineCard__type">
                        {this.renderByType()}
                    </div>

                    {this.renderFooter()}
                </div>
            </div>
        );
    }

    renderByType() {
        const item = this.props.item;

        if (this.props.wizard) {
            return (
                <WizardTimelineCard
                    item={item}
                    onSave={this.props.onSave}
                    onDelete={this.props.onDelete}
                    onCancel={this.props.onCancelWizard}
                    onChange={this.props.onChange}
                    scale={this.props.scale}
                    isVerticalView={this.props.isVerticalView}
                />
            );
        }

        const type = item.type;
        let typeClass = this.constructor.types[type];

        if (!typeClass) {
            console.warn(
                type + " card type not supported. Item #" + item.rowid
            );
            typeClass = NotSupportedCard;
        }

        // $FlowFixMe
        return React.createElement(typeClass, this.props);
    }

    renderFooter() {
        if (this.props.wizard) return null;

        return (
            <footer className="TimelineCard__footer">
                {this.renderNonEditableFooter()}
                {this.renderEditableFooter()}
            </footer>
        );
    }

    renderNonEditableFooter() {
        if (this.props.editable) return null;

        return (
            <TimelineCardSocial
                item={this.props.item}
                userId={this.props.userId}
                onReact={this.props.onReact}
                onForward={this.handleSeek}
            />
        );
    }

    renderEditableFooter() {
        if (!this.props.editable) return null;

        return (
            <div className="TimelineCard__editable-footer">
                <EditButton
                    onClick={this.props.onRequestEdit}
                    text="Edit Card"
                />
                {this.props.item.isSaved && (
                    <TimelineItemDelete onDelete={this.props.onDelete} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/TimelineCard.js